import * as HSActions from 'ApplicationEntry/ducks/ProductsRiders/heartStroke';
import {isValidPolicyNumberPaperElectronic} from 'ApplicationEntry/models/EnteredPolicyNumber';
import * as HS from 'ApplicationEntry/models/ProductsRiders/HeartStroke/OrdinaryHeartStroke';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from '../../ErrorMessages';
import './../ProductRiders.sass';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';

import VariableCodeRiderInformation from '../VariableCodeRiderInformation';
import {Loaded} from 'Core/models/Async';

type HeartStrokeProps = {
  heartStroke: HS.OrdinaryHeartStroke;
};

const HeartStroke = (props: HeartStrokeProps) => {
  const dispatch = useDispatch();
  const {
    planType,
    productType,
    overrideBillForm,
    calculatedPremium,
    riderInformation,
    cwa,
    policyNumber,
    replacement,
    section125,
    baseUnits,
  } = props.heartStroke;
  const [planTypeBlurred, setBlurPlanType] = useState(false);
  const [policyNumberBlurred, setPolicyNumberBlurred] = useState(false);
  const showPlanTypeError = planTypeBlurred && planType.key === 'Empty';
  const [planTypeLabel, setPlanTypeLabel] = useState<HTMLLabelElement | null>();
  const [typeBlurred, setBlurType] = useState(false);
  const [typeLabel, setTypeLabel] = useState<HTMLLabelElement | null>();
  const showTypeError = typeBlurred && productType.key === 'Empty';
  const showPolicyNumberError = policyNumberBlurred && !isValidPolicyNumberPaperElectronic(policyNumber) && replacement;

  return (
    <>
      <div className="product-riders-section__policy-type" id="heart-stroke-section">
        <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
          <div className="product-riders-section__policy-type__form__row">
            <Grid container spacing={4}>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={showTypeError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setTypeLabel} id="heart-stroke-product-type-label">
                    Product Type
                  </InputLabel>
                  <Select
                    labelId="heart-stroke-label--product-type"
                    labelWidth={typeLabel?.clientWidth}
                    id="heart-stroke-product-type"
                    value={productType.key === 'Empty' ? '' : productType.value}
                    onBlur={() => setBlurType(true)}
                    onChange={event => dispatch(HSActions.changeProductType(event.target.value as string))}
                    displayEmpty
                  >
                    {HS.typeList.map(product => (
                      <MenuItem value={product} key={product}>
                        {product}
                      </MenuItem>
                    ))}
                  </Select>
                  {showTypeError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
                </FormControl>
              </Grid>
            </Grid>

            {productType.key === 'NonEmpty' ? (
              <>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={3}>
                    <FormControl
                      error={showPlanTypeError}
                      variant="outlined"
                      className="product-riders-section__policy-type__form__row--field"
                    >
                      <InputLabel ref={setPlanTypeLabel} id="heart-stroke-plantype-label">
                        Plan Type
                      </InputLabel>
                      <Select
                        labelId="heart-stroke-label-plantype"
                        labelWidth={planTypeLabel?.clientWidth}
                        id="critical-illness-plantype"
                        value={planType.key === 'Empty' ? '' : planType.value}
                        onBlur={() => setBlurPlanType(true)}
                        onChange={event => {
                          dispatch(HSActions.changePlanType(event.target.value as string));
                        }}
                      >
                        <MenuItem value="IND">Individual</MenuItem>
                        <MenuItem value="FAMILY">Family</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="heart-stroke-replacement"
                          checked={replacement}
                          onChange={() => dispatch(HSActions.changeReplacement(!replacement))}
                        />
                      }
                      label={<Typography className="case-details-section__checkbox-label">Replacement</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="heart-stroke-policy-number"
                      label="Policy Number"
                      variant="outlined"
                      placeholder="Enter Policy Number"
                      margin="normal"
                      fullWidth
                      error={showPolicyNumberError}
                      helperText={showPolicyNumberError ? ErrorMessages.INVALID_POLICY_NUMBER : ''}
                      className="product-riders-section__policy-type__form__row--field"
                      value={policyNumber.key !== 'ValidPolicyNumber' || !replacement ? '' : policyNumber.value.value}
                      onBlur={() => setPolicyNumberBlurred(true)}
                      onChange={event => dispatch(HSActions.changePolicyNumber(event.target.value as string))}
                      disabled={!replacement}
                      inputProps={{
                        maxLength: 10,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="heart-stroke-override-bill-form"
                          checked={overrideBillForm}
                          onChange={() => dispatch(HSActions.changeOverrideBillForm(!overrideBillForm))}
                        />
                      }
                      label={<Typography>Override Bill Form To Direct</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="heart-stroke-section125"
                          checked={section125}
                          onChange={() => dispatch(HSActions.changeSection125(!section125))}
                        />
                      }
                      label={<Typography>Section 125</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="heart-stroke-premium"
                      label="Premium"
                      variant="outlined"
                      placeholder="Enter Premium"
                      margin="normal"
                      fullWidth
                      className="product-riders-section__policy-type__form__row--field"
                      value={calculatedPremium.value}
                      onChange={event => {
                        dispatch(HSActions.changePremium(event.target.value as string));
                        dispatch(HSActions.changeCalculatedPremium(event.target.value as string));
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="heart-stroke-cwa"
                      label="CWA"
                      variant="outlined"
                      placeholder="Enter CWA"
                      margin="normal"
                      fullWidth
                      className="product-riders-section__policy-type__form__row--field"
                      value={cwa.value}
                      onChange={event => dispatch(HSActions.changeCWA(event.target.value as string))}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl
                      error={showTypeError}
                      variant="outlined"
                      className="product-riders-section__policy-type__form__row--field"
                    >
                      <InputLabel ref={setTypeLabel} id="heart-stroke-type-label">
                        Base Units
                      </InputLabel>
                      <Select
                        labelId="heart-stroke-label-type"
                        labelWidth={typeLabel?.clientWidth}
                        id="heart-stroke-type"
                        value={baseUnits.key === 'Empty' ? '' : baseUnits.value}
                        onBlur={() => setBlurType(true)}
                        onChange={event => dispatch(HSActions.changeBaseUnits(event.target.value as string))}
                        displayEmpty
                      >
                        {HS.baseUnits.map(baseUnit => (
                          <MenuItem value={baseUnit} key={baseUnit}>
                            {baseUnit}
                          </MenuItem>
                        ))}
                      </Select>
                      {showTypeError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
                    </FormControl>
                  </Grid>
                </Grid>

                <VariableCodeRiderInformation
                  riderInformation={new Loaded(riderInformation)}
                  changeRiderInformationAction={HSActions.changeRiderInformation}
                  identifier="ordinary-heart-stroke"
                />
              </>
            ) : null}
          </div>
        </form>
      </div>
    </>
  );
};

export default HeartStroke;
